<template>
  <form class="container-fluid m-0 p-0" @submit.prevent>
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Add User</span>

        <span class="float-right py-1 mx-2 pr-4">
          <button
            type="submit"
            class="btn btn-xs btn-outline-primary px-2 mr-1"
            @click="updateAnnouncement()"
          >
            <span class="fas fa-save"></span>
            Save
          </button>

          <button
            class="btn btn-xs btn-outline-secondary px-2 mr-1"
            title="Go to Previous Page"
            @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>
    <div class="row text-left border-top py-2 ml-1">
      <div class="col-5 h-100 my-auto py-2 px-3 m-0">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-2 col-form-label"
            >Message</label
          >
          <div class="col-sm-10">
            <textarea
              class="form-control"
              rows="2"
              v-model="announcement.message"
            ></textarea>
          </div>
        </div>

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label"
            >Type</label
          >
          <div class="col-sm-10">
            <select
              class="form-control"
              v-model="announcement.announcement_type_id"
            >
              <option value="" disabled selected>
                --Please Select Announcement Type--
              </option>
              <option
                :value="announcementType.id"
                v-for="announcementType in announcementTypes"
                :key="announcementType.id"
              >
                {{ announcementType.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label"
            >Start Date</label
          >
          <div class="col-sm-10">
            <input
              type="date"
              class="form-control"
              v-model="announcement.start_date"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="inputPassword" class="col-sm-2 col-form-label"
            >End Date</label
          >
          <div class="col-sm-10">
            <input
              type="date"
              class="form-control"
              v-model="announcement.end_date"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      id: this.$route.params.id,
      announcement: {
        id: null,
        message: null,
        announcement_type_id: null,
        start_date: null,
        end_date: null,
      },
    };
  },
  computed: {
    ...mapState({
      announcementTypes(state) {
        return state.AnnouncementTypeModule.announcementTypes;
      },
    }),
  },
  methods: {
    async fetchAnnouncement() {
      const self = this;
      this.$store
        .dispatch("AnnouncementModule/fetchAnnouncement", this.id)
        .then((response) => {
          self.announcement = response.data;
        });
    },
    async fetchAnnouncementTypes() {
      this.$store.dispatch("AnnouncementTypeModule/fetchAnnouncementTypes");
    },
    async updateAnnouncement() {
      let self = this;
      this.$store
        .dispatch("AnnouncementModule/updateAnnouncement", this.announcement)
        .then(() => {
          Swal.fire({
            title: "Announcement Saved",
            icon: "info",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value)
              self.$router.push({ path: "/admin/announcement/index" });
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  created() {
    this.fetchAnnouncement();
    this.fetchAnnouncementTypes();
  },
};
</script>

<style lang="scss" scoped></style>
